import { render } from "./CardSliderPagination.vue?vue&type=template&id=f80bc398"
import script from "./CardSliderPagination.vue?vue&type=script&lang=js"
export * from "./CardSliderPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__